import { ApplicationState } from '../../index';
import { call, put, select } from 'redux-saga/effects';
import {
  EntryOrderService,
  IShipToCustomerItem
} from '../../../services/EntryOrder';
import {
  loadReceiversForBPLoading,
  loadReceiversForBPSuccess
} from './actions';
import { ICustomer } from '../customers/types';

export function* loadReceiversFromCustomer(params: {
  type: string;
  payload: ICustomer;
}) {
  const receiver = params.payload;

  const items: IShipToCustomerItem[] = [
    {
      name: receiver.name,
      customerId: receiver.customerId,
      address: receiver.locality.address,
      city: receiver.locality.city,
      state: receiver.locality.state,
      postalCode: receiver.locality.zipCode,
      taxNumber: receiver.taxNumber as string
    }
  ];
  yield put(loadReceiversForBPSuccess(params.payload.customerId, items));
}

export function* loadReceiversForBP(params: {
  type: string;
  payload: string;
}): any {
  const customerId = params.payload;
  const actualLoading = yield select(selectIsLoadingReceiversForBP, customerId);

  if (actualLoading) {
    return;
  }

  const actualItems = yield select(selectReceiversForBP, customerId);

  let items: IShipToCustomerItem[];

  if (actualItems.length > 0) {
    items = actualItems;
  } else {
    yield put(loadReceiversForBPLoading(customerId));
    const service = new EntryOrderService();
    const newItems = yield call(
      [service, service.loadShipToCustomer],
      customerId
    );
    items = newItems;
  }
  yield put(loadReceiversForBPSuccess(customerId, items));
}

const selectIsLoadingReceiversForBP = (
  state: ApplicationState,
  customerId: string
) => {
  const receiversState = state.entryOrderReceivers;

  return (
    (receiversState?.loading && receiversState?.customerId == customerId) ||
    false
  );
};

const selectReceiversForBP = (state: ApplicationState, customerId: string) => {
  const receiversState = state.entryOrderReceivers;

  if (!receiversState || receiversState.customerId !== customerId) return [];

  return receiversState.receivers;
};
